import React, { Component } from "react";
import { connect } from "react-redux";
import { addChatbotTenant, updateChatbotTenant, deleteChatbotTenant, fetchChatbotTenants } from "../../Store/Slices/Admin/ManagerChatbot";

class ChatbotManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: "",
            selectedTenant: null,
            isNew: false,
            form: {
                pageId: "",
                pageName: "",
                accessToken: "",
                relayEndpoint: "",
                aiProfile: "",
            }
        };
    }

    componentDidMount() {
        this.props.fetchChatbotTenants();
    }

    handleSelectTenant = (tenant) => {
        this.setState({
            selectedTenant: tenant,
            isNew: false,
            form: {
                pageId: tenant.pageId || "",
                pageName: tenant.pageName || "",
                accessToken: tenant.accessToken || "",
                relayEndpoint: tenant.relayEndpoint || "",
                aiProfile: tenant.aiProfile || ""
            }
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            form: { ...prev.form, [name]: value }
        }));
    };

    handleSearchChange = (e) => {
        this.setState({ search: e.target.value });
    };

    handleCreateNew = () => {
        this.setState({
            selectedTenant: null,
            isNew: true,
            form: {
                pageId: "",
                pageName: "",
                accessToken: "",
                relayEndpoint: "",
                aiProfile: "",
            }
        });
    };

    handleCancel = () => {
        this.setState({
            selectedTenant: null,
            isNew: false,
            form: {
                pageId: "",
                pageName: "",
                accessToken: "",
                relayEndpoint: "",
                aiProfile: "",
            }
        });
    };

    handleDelete = () => {
        const { selectedTenant } = this.state;

        if (!selectedTenant) return;

        const confirmed = window.confirm(
            `Delete tenant "${selectedTenant.pageName}"?`
        );

        if (!confirmed) return;

        this.props.deleteChatbotTenant(selectedTenant.id);

        this.handleCancel();
    };

    handleSave = () => {
        const { isNew, selectedTenant, form } = this.state;
        if (isNew) {
            this.props.addChatbotTenant(form);
        } else {
            this.props.updateChatbotTenant({
                tenantId: selectedTenant.id,
                payload: form
            })
        }

        this.setState({
            selectedTenant: null,
            isNew: false,
            form: {
                pageId: "",
                pageName: "",
                accessToken: "",
                relayEndpoint: "",
                aiProfile: "",
            }
        });
    };

    getFilteredTenants = () => {
        const { tenants } = this.props;
        const { search } = this.state;

        if (!search) return tenants || [];

        return (tenants || []).filter((t) =>
            (t.pageId || "").toLowerCase().includes(search.toLowerCase()) ||
            (t.pageName || "").toLowerCase().includes(search.toLowerCase())
        );
    };

    render() {
        const tenants = this.getFilteredTenants();
        const { form, selectedTenant, isNew } = this.state;

        return (
            <div className="flex h-screen bg-gray-50 text-gray-800">

                {/* SIDEBAR */}
                <div className="w-80 border-r bg-white flex flex-col">

                    <div className="p-4 border-b">
                        <div className="flex items-center justify-between">
                        <h2 className="text-lg font-semibold">Tenants</h2>

                            <button
                                onClick={this.handleCreateNew}
                                className="text-xs px-3 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                            >
                                + New
                            </button>
                        </div>

                        <input
                            value={this.state.search}
                            onChange={this.handleSearchChange}
                            placeholder="Search page ID or name..."
                            className="mt-3 w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                        />
                    </div>

                    <div className="flex-1 overflow-y-auto p-2 space-y-2">
                        {tenants.map((t) => {
                            const isActive =
                                selectedTenant?.pageId === t.pageId && !isNew;

                            return (
                                <div
                                    key={t.pageId}
                                    onClick={() => this.handleSelectTenant(t)}
                                    className={`cursor-pointer rounded-lg p-3 border transition 
                                        ${isActive
                                            ? "bg-blue-50 border-blue-400"
                                            : "bg-white hover:bg-gray-100 border-gray-200"
                                        }`}
                                >
                                    <div className="font-medium text-sm">
                                        {t.pageName}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        {t.id}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        {t.pageId}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* MAIN PANEL */}
                <div className="flex-1 p-8 overflow-y-auto">

                    <div>

                        <h1 className="text-2xl font-bold mb-6">
                            {isNew ? "Create Tenant" : "Tenant Configuration"}
                        </h1>
                        {!isNew && selectedTenant && (
                            <button
                                onClick={this.handleDelete}
                                className="px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-lg mb-3"
                            >
                                Delete Tenant
                            </button>
                        )}

                        {!selectedTenant && !isNew ? (
                            <div className="text-gray-500 bg-white p-6 rounded-xl border">
                                Select a tenant or create a new one
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className="bg-white border rounded-xl p-6 space-y-5 shadow-sm">
                                    <div>
                                        <label className="text-sm font-medium">Page ID</label>
                                        <input
                                            name="pageId"
                                            value={form.pageId}
                                            onChange={this.handleChange}
                                            className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm font-medium">Page Name</label>
                                        <input
                                            name="pageName"
                                            value={form.pageName}
                                            onChange={this.handleChange}
                                            className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm font-medium">Access Token</label>
                                        <input
                                            name="accessToken"
                                            value={form.accessToken}
                                            onChange={this.handleChange}
                                            className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm font-medium">Relay Domain</label>
                                        <input
                                            name="relayEndpoint"
                                            value={form.relayEndpoint}
                                            onChange={this.handleChange}
                                            className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                        />
                                    </div>

                                    <div className="flex justify-end pt-2 gap-2">
                                        {isNew && (
                                            <button
                                                onClick={this.handleCreateNew}
                                                className="px-4 py-2 text-sm border rounded-lg hover:bg-gray-100"
                                            >
                                                Cancel
                                            </button>
                                        )}

                                        <button
                                            onClick={this.handleSave}
                                            className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg shadow"
                                        >
                                            {isNew ? "Create Tenant" : "Save Changes"}
                                        </button>
                                    </div>

                                    </div>
                                    <div className="bg-white border rounded-xl p-6 space-y-5 shadow-sm">
                                        <div>
                                            <label className="text-sm font-medium">Agent Profile Prompt</label>

                                            <textarea
                                                name="aiProfile"
                                                value={form.aiProfile}
                                                onChange={this.handleChange}
                                                rows={5}
                                                className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none resize-y"
                                            />
                                        </div>
                                    </div>

                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tenants: state.chatbot.tenants
});

export default connect(mapStateToProps, { addChatbotTenant, updateChatbotTenant, deleteChatbotTenant, fetchChatbotTenants })(ChatbotManager);